import { API_BASE_URL, API_ENDPOINTS } from "../constants/api";

interface AdSsoVerifyResponse {
  is_authenticated: boolean;
  token_expiry: string; // ISO 8601 timestamp, e.g. "2026-09-17T14:05:25Z"
}

export const useAdssoLoginGuard = () => {
  const redirect_uri = `${API_BASE_URL}${API_ENDPOINTS.ADSSO_LOGIN_GUARD}`;

  const ssoLoginRedirect = () => {
    const nonce =
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);
    // Set nonce cookie for backend validation
    document.cookie = `AD_NONCE=${nonce}; Domain=.${new URL(API_BASE_URL || "").hostname}; Path=/; Secure; Max-Age=300`;
    window.location.href = `${process.env.REACT_APP_AD_SSO_BASE_URL}${process.env.REACT_APP_AD_SSO_AUTHORIZE_URL}?client_id=${process.env.REACT_APP_AD_SSO_CLIENT_ID}&scope=openid+profile&response_type=code+id_token&response_mode=form_post&redirect_uri=${encodeURIComponent(redirect_uri)}&nonce=${nonce}`;
  };

  /**
   * Calls the ADSSO verify endpoint to check if the user has a valid AD_ATKN cookie.
   * The AD_ATKN cookie is HttpOnly, so it cannot be read by JavaScript.
   * The verify endpoint reads the cookie server-side and returns { is_authenticated, token_expiry }.
   * Uses raw fetch (instead of Http service) to bypass the maintenance guard — auth verification
   * must happen regardless of maintenance state.
   *
   * @returns true if the user is authenticated, false otherwise (including errors)
   */
  const verifyAdssoToken = async (): Promise<boolean> => {
    try {
      const url = `${API_BASE_URL}${API_ENDPOINTS.ADSSO_LOGIN_VERIFY}`;
      const response = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
      });
      if (!response.ok) return false;
      const data: AdSsoVerifyResponse = await response.json();
      return data.is_authenticated === true;
    } catch (error) {
      console.error("ADSSO verify failed:", error);
      return false;
    }
  };

  return { ssoLoginRedirect, verifyAdssoToken };
};
